.tile {
  background: var(--colors-grays-ultralight);
  border: 2px solid transparent;
  border-radius: 12px;
  cursor: pointer;
  transition: border-color 0.15s ease;
}

.tile:hover:not(.disabled, .selected) {
  border-color: var(--colors-grays-light);
}

.tile.selected {
  border-color: var(--colors-primary-main);
}

.tile.disabled {
  opacity: 0.5;
  cursor: default;
}
